<template>
    <nav class="navbar-dark" :class="{ 'scrolled': isScrolled }">
        <div class="container">
            <div class="navbar-content">
                <!-- Logo -->
                <a href="#home" class="navbar-logo" @click.prevent="scrollToSection('home')">
                    <div class="logo-icon">
                        <img src="/assets/img/devlusaja_logo.png" alt="devlusaja logo">
                    </div>
                </a>

                <!-- Menu desktop -->
                <ul class="navbar-menu">
                    <li v-for="item in menuItems" :key="item.id">
                        <a
                            :href="'#' + item.section"
                            class="menu-link"
                            :class="{ 'active': activeSection === item.section }"
                            @click.prevent="scrollToSection(item.section)">
                            {{ item.label }}
                        </a>
                    </li>
                </ul>

                <!-- Toggle mobile -->
                <button class="menu-toggle" @click="toggleMobileMenu">
                    <i class="fa" :class="mobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
                </button>
            </div>
        </div>

        <!-- Menu mobile -->
        <transition name="mobile-menu">
            <div v-if="mobileMenuOpen" class="mobile-menu">
                <ul class="mobile-menu-list">
                    <li v-for="item in menuItems" :key="item.id">
                        <a
                            :href="'#' + item.section"
                            class="mobile-menu-link"
                            :class="{ 'active': activeSection === item.section }"
                            @click.prevent="scrollToSectionMobile(item.section)">
                            {{ item.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </transition>
    </nav>
</template>

<script>
export default {
    name: 'Navbar',
    data() {
        return {
            isScrolled: false,
            activeSection: 'home',
            mobileMenuOpen: false,
            menuItems: [
                { id: 1, label: 'Inicio', section: 'home' },
                { id: 2, label: 'Sobre mí', section: 'about' },
                { id: 3, label: 'Servicios', section: 'services' },
                { id: 4, label: 'Experiencia', section: 'experience' },
                { id: 5, label: 'Tecnologías', section: 'skills' },
                { id: 6, label: 'Proyectos', section: 'enterprise_projects' },
                { id: 7, label: 'Portafolio', section: 'projects' },
                { id: 8, label: 'Contacto', section: 'contact' }
            ]
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.observeSections();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.isScrolled = window.scrollY > 50;
        },
        scrollToSection(section) {
            const element = document.getElementById(section);
            if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        },
        scrollToSectionMobile(section) {
            this.mobileMenuOpen = false;
            setTimeout(() => {
                this.scrollToSection(section);
            }, 300);
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        observeSections() {
            const options = {
                root: null,
                rootMargin: '-100px',
                threshold: 0.3
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.activeSection = entry.target.id;
                    }
                });
            }, options);

            this.menuItems.forEach(item => {
                const element = document.getElementById(item.section);
                if (element) {
                    observer.observe(element);
                }
            });
        }
    }
}
</script>

<style scoped>
.navbar-dark {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(26, 29, 41, 0.95);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
    padding: 5px 0;
}

.navbar-dark.scrolled {
    padding: 15px 0;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.navbar-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* Logo */
.navbar-logo {
    text-decoration: none;
    display: block;
}

.logo-icon {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.logo-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.navbar-logo:hover .logo-icon {
    transform: scale(1.1);
}

/* Menu desktop */
.navbar-menu {
    display: flex;
    list-style: none;
    gap: 40px;
    margin: 0;
    padding: 0;
}

.menu-link {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease;
    position: relative;
    padding: 5px 0;
}

.menu-link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: #ff6b6b;
    transition: width 0.3s ease;
}

.menu-link:hover,
.menu-link.active {
    color: #fff;
}

.menu-link:hover::after,
.menu-link.active::after {
    width: 100%;
}

/* Toggle mobile */
.menu-toggle {
    display: none;
    background: none;
    border: none;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    padding: 5px;
}

/* Menu mobile */
.mobile-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: rgba(26, 29, 41, 0.98);
    backdrop-filter: blur(10px);
    padding: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.mobile-menu-list li {
    margin-bottom: 15px;
}

.mobile-menu-link {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    display: block;
    padding: 10px 15px;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.mobile-menu-link:hover,
.mobile-menu-link.active {
    color: #fff;
    background: rgba(255, 107, 107, 0.1);
    border-left: 3px solid #ff6b6b;
}

/* Transiciones mobile menu */
.mobile-menu-enter-active,
.mobile-menu-leave-active {
    transition: all 0.3s ease;
}

.mobile-menu-enter-from,
.mobile-menu-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

/* Responsive */
@media (max-width: 768px) {
    .navbar-menu {
        display: none;
    }

    .menu-toggle {
        display: block;
    }
}
</style>
